import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Navbar from '@tabeeb/modules/sessionTabs'
import PlayerToolbar from '@tabeeb/modules/playerToolbar'
import EditUniqueAIObjectConnectionsDialog from '@tabeeb/modules/artificialIntelligence/components/EditUniqueAIObjectConnectionsDialog'
import SelectedPagesForMerging from '@tabeeb/modules/contentSharings/components/SelectedPagesForMerging'
import SplatModelTimeline from '@tabeeb/modules/splatModel'
import ReadonlyPlayerToolbar from '@tabeeb/modules/playerToolbar/components/ReadonlyPlayerToolbar'
import { getIsAnyTabExpanded } from '@tabeeb/modules/sessionTabs/selectors'
import UsersToolbar from '../../../users'
import PresentationContent from './PresentationContent'
import RecordingProgressBarContainer from '../../recording/containers/RecordingProgressBarContainer'
import SwitchRecordedUserConfirmationDialog from '../../recording/components/SwitchRecordedUserConfirmationDialog'
import { PlayerProgressBarPanel } from '../../player'
import CustomVideo from '../../customVideo'
import SpatialViewImagesListContainer from '../../spatialModel/containers/SpatialViewImagesListContainer'
import ThreedeeImagesListContainer from '../../3dmodel/containers/ThreedeeImagesListContainer'
import BentleyImagesListContainer from '../../bentleyModel/containers/BentleyImagesListContainer'
import ShareSessionPagesListContainer from '../../shareSessionPagesList/containers/ShareSessionPagesListContainer'
import ShareSessionByFormDialog from '../../shareSessionPagesList/components/ShareSessionByFormDialog'
import ReviewSessionPagesListContainer from '../../reviewSessionPagesList/containers/ReviewSessionPagesListContainer'
import BentleyAnalyticsReportModelsListContainer from '../../bentleyAnalyticsReport'
import ClassificationAnnotationsPagesTimeline from '../../classificationAnnotationsPagesTimeline'
import EditUniqueAIObjectDialog from '../../artificialIntelligence/components/EditUniqueAIObjectDialog'
import { TabPanelLocation } from '../../../Enums'

const Presentation = ({ readonly = false }) => {
  const currentPanel = useSelector((state) => state.navbar.bottom)
  const isPresentationHidden = useSelector(getIsAnyTabExpanded)

  return (
    <main
      className='tabeebPresentationToolbar'
      style={{
        display: isPresentationHidden ? 'none' : 'flex',
      }}
    >
      <PresentationContent readonly={readonly} />

      <SwitchRecordedUserConfirmationDialog />

      <RecordingProgressBarContainer />
      <PlayerProgressBarPanel />
      {readonly ? <ReadonlyPlayerToolbar /> : <PlayerToolbar />}

      <EditUniqueAIObjectDialog />
      <EditUniqueAIObjectConnectionsDialog />

      <Navbar location={TabPanelLocation.Bottom} readonly={readonly} />
      <div className='bottom-toolbar' style={{ display: currentPanel !== null ? 'flex' : 'none' }}>
        <UsersToolbar />
        <CustomVideo />
        <SpatialViewImagesListContainer />
        <ThreedeeImagesListContainer />
        <BentleyImagesListContainer />
        <SplatModelTimeline />
        <ShareSessionPagesListContainer />
        <ShareSessionByFormDialog />
        <ReviewSessionPagesListContainer />
        <BentleyAnalyticsReportModelsListContainer />
        <SelectedPagesForMerging />
        <ClassificationAnnotationsPagesTimeline />
      </div>
    </main>
  )
}

Presentation.propTypes = {
  readonly: PropTypes.bool,
}

export default Presentation
